import { defineSlotRecipe } from '@chakra-ui/react';

export const selectSlotRecipe = defineSlotRecipe({
  slots: [
    'root',
    'control',
    'trigger',
    'valueText',
    'placeholder',
    'indicatorGroup',
    'indicator',
    'content',
    'item',
    'itemText',
    'itemIndicator',
  ],
  base: {},
  variants: {
    variant: {
      outline: {},
      subtle: {},
      ghost: {
        trigger: {
          border: 'none',
          borderWidth: '0',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'ghost',
  },
});
